import { useMyAssortmentTFunction } from '@retail/my-assortment/i18n';
import { Chip } from '@shared/components';
import { PriceControlChangeType } from '@retail/price-control/types';
import { Stack, useTheme } from '@mui/material';

interface Props {
  trigger: PriceControlChangeType;
}

export function PriceChangeTriggerChip({ trigger }: Props) {
  const t = useMyAssortmentTFunction();
  const theme = useTheme();
  const { tint } = theme.vars.palette.semantic;
  const purchaseAgreement = { backgroundColor: tint.sky.soft, textColor: tint.sky.text };
  const priceSuggestion = { backgroundColor: tint.lavender.medium, textColor: tint.lavender.text };

  switch (trigger) {
    case 'AGREEMENT_PRICE_AND_PRICE_SUGGESTION':
      return (
        <Stack direction="row" gap={0.5}>
          <Chip
            size="small"
            {...purchaseAgreement}
            label={t('myAssortment.priceControl.trigger.purchaseAgreement')}
          />
          <Chip
            size="small"
            {...priceSuggestion}
            label={t('myAssortment.priceControl.trigger.priceSuggestion')}
          />
        </Stack>
      );
    case 'AGREEMENT_PRICE':
      return (
        <Chip
          size="small"
          {...purchaseAgreement}
          label={t('myAssortment.priceControl.trigger.purchaseAgreement')}
        />
      );

    case 'PRICE_SUGGESTION':
      return (
        <Chip
          size="small"
          {...priceSuggestion}
          label={t('myAssortment.priceControl.trigger.priceSuggestion')}
        />
      );
    default:
      return '';
  }
}
